import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { authGuard, permissionGuard } from './guards'
import i18n from '@/i18n'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0, behavior: 'smooth' }
  },
})

router.beforeEach(authGuard)
router.beforeEach(permissionGuard)

router.afterEach((to) => {
  const titleKey = to.meta.titleKey
  const appName = import.meta.env.VITE_APP_NAME ?? 'ShopsZe Admin'
  if (titleKey) {
    document.title = `${i18n.global.t(titleKey)} · ${appName}`
  } else {
    document.title = appName
  }
})

export default router
export { routes }
